import type { FaireProductEntity } from "../../entity_types/product";

export const p_9g3jkx4ywg: FaireProductEntity = {
  token: "p_9g3jkx4ywg",
  type: "product",
  name: "Golden Shore Shower Bomb | Amber + Driftwood",
  brandToken: "b_bz352u88",
  brandName: "Thulisa Naturals™  | Bath + Body",
  imageUrl:
    "https://cdn.faire.com/fastly/8cfbb33b3b349e49c3feebc528ed5e1539d54e465554205ef78d048f13243ea1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6cac22fb2c89b53737c0b90e32c7063d82d9d8aaf69c9b9dda8345a9c6e25b44.png",
    "https://cdn.faire.com/fastly/d478d8e2baa49402d319315e77fd5b1ce9a5d302448c1e4136a2ae53ded6020b.png",
    "https://cdn.faire.com/fastly/a2fa3d04a7a1b5e12d1b08bf1c536392d689edfc1cd6a0f6675e5ed718079670.png",
    "https://cdn.faire.com/fastly/5b10c47630e719a69f455736e61c65a5fbb4bafa43428e2eb2c686d79c40c104.png",
    "https://cdn.faire.com/fastly/deed4fb06d45703bc4f62e6e20f60f94608acf4a283aa73d2f45569ac965e534.jpeg",
    "https://cdn.faire.com/fastly/23a67d9fa67a5db09c318323116a6928ca7cbc925ebdbe2604ae78c81cd3006c.png",
  ],
  priceDollars: 5.25,
  description:
    "Golden Shore aromatherapy shower steamers bring a warm, grounding blend of cedarwood, caraway, orange peel, and patchouli essential oils to your everyday shower routine — no bathtub needed.\n\nEach box contains 2 aromatherapy shower steamers. Simply sprinkle a few drops of water onto the steamer, place it on the shower floor or tub ledge once it begins to fizz, and breathe deeply.\n\nHandcrafted in small batches in Fairfax, VA with clean ingredients. Leaping Bunny Certified, cruelty-free, and packaged in recyclable and compostable materials. Certified Women-Owned Business. Every purchase helps provide free lunches to vulnerable preschoolers in South Africa.",
  tags: [],
  msrpDollars: 10.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:49.229Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
